module.exports = __webpack_public_path__ + "img/Metastasis-OVCA_10X_OC.088039ba.png";